import { render, staticRenderFns } from "./BackOriginalUser.vue?vue&type=template&id=afcb8efa"
import script from "./BackOriginalUser.vue?vue&type=script&lang=js"
export * from "./BackOriginalUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports